<template>
  <div class="header">
    <div class="header-box clearfix">
      <div class="header-lt fl">
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-submenu index="nan">
            <template slot="title">
               导航
             </template>
            <el-submenu v-if="i != menus.length-1" :index="''+i" v-for="(t,i) in menus" :key="i">
              <template slot="title">{{t.name}}</template>
              <el-menu-item :index="i+'_'+t.id+'_'+n.id+'_'+n.name" v-for="(n,j) in t.child" :key="j">
                {{n.name}}
              </el-menu-item>
            </el-submenu>
            <el-menu-item :index="elmenu.index+'_'+elmenu.id+'_null_'">{{elmenu.name}}</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>


      <div class="header-logo">
        <router-link to="/">
          <img src="../../assets/images/logo.png"
               alt="">
        </router-link>
      </div>
<!--       <div v-if="!isLoginDate" class="header-rt fr">
        <router-link to="/system/login">登录</router-link>
        /
        <router-link to="">注册</router-link>
      </div> -->
      <div class="header-rt1 fr">
        <el-button @click="gotoC"
                   v-if="admin ===1">
          进入后台管理
        </el-button>
        <span class="nickname">{{username||'管理员'}}</span>

        <span class="out"
              @click="out">退出</span>
      </div>
      

    </div>
  </div>
</template>
<script>
export default {
  name: 'hd',
  data: () => ({
    sea: false,
    // isLoginDate: true,
    admin: 0,
    username: '',
    options: [],
    menus:[],
    elmenu:{},
    value: '',
    word: '',
    list: [],
    activeIndex:'',
  }),
  //函数放置
  methods: {
    handleSelect (key, keyPath) {
      this.activeIndex = key;
      var arr = key.split('_');
      localStorage.setItem('siftingList',arr[3]);
      this.$router.push({
        path: '/list',
        query: {
          m_type: parseInt(arr[0]) + 1,
          cid:parseInt(arr[1]),
          id:parseInt(arr[2])
        }
      })
    },

    gotoC () {
      this.$router.push('/system/museum/museumlist?cid=1&name=国内展馆')
    },
    initUserInfo () {
      let userInfo = JSON.parse(localStorage.getItem(
        'user__info',
      )) || {};
      this.admin = userInfo.is_admin
      this.username = userInfo.username
      // {"is_admin":1,"nickname":null}
    },
    //            博物馆搜索
    searchInput: function () {
      $(".header-search input").focus();
      let token_value = localStorage.getItem('token');
      let _this = this;

      if (this.sea == true) {

        if (this.value == '') {
          _this.$notify.error({
            title: '错误',
            message: '类型不能为空！',
          });
          return false;
        }

        if (this.word == '') {
          _this.$notify.error({
            title: '错误',
            message: '搜索不能为空！',
          });
          return false;
        } else {
          if (this.value == 1) {

            this.$http.get(this.$store.state.api + '/search.html?token=' + token_value + '&type=' + this.value + '&word=' + this.word).then(function (res) {

              _this.list = res.data.data.data;
              if (_this.$route.path == '/list/searchone') {
                //当前是搜索页面
                _this.$store.state.seachBol = !_this.$store.state.seachBol;
              }
              _this.$router.push({
                path: '/list/searchone',
                query: {
                  type: _this.value,
                  word: _this.word,
                  mid: _this.list.id
                }
              })
            }).catch(function (err) {
              console.log(err);
            })
          } else if (this.value == 2) {


            this.$http.get(this.$store.state.api + '/search.html?token=' + token_value + '&type=' + this.value + '&word=' + this.word).then(function (res) {
              _this.list = res.data.data.data;
              _this.$router.push({
                path: '/list/searchonet',
                query: {
                  type: _this.value,
                  word: _this.word,
                }
              })
            }).catch(function (err) {
              console.log(err);
            })
          } else if (this.value == 3) {

            this.$http.get(this.$store.state.api + '/search.html?token=' + token_value + '&type=' + this.value + '&word=' + this.word).then(function (res) {
              _this.list = res.data.data.data;
              //                                console.log(_this.list)
              _this.$router.push({
                path: '/list/searchtwo',
                query: {
                  type: _this.value,
                  word: _this.word,
                }
              })
            }).catch(function (err) {
              console.log(err);
            })
          }

        }
      }

    },
    out () {
      localStorage.removeItem('token');
      // this.isLogin = false;
        this.$store.commit('isLoginDate',false)
      if (this.$route.query.activity == '1') {
        return false;
      }
      this.$router.push({
        path: '/system/login',
      })
    },

    getAllMenus(token){
      this.$http.get(this.$store.state.api + '/common/column/all.html?token=' + token + '&tree=true').then((res) => {
        if(res.data.code == 200){
          let len = res.data.data.length;
          let arr = res.data.data;
          this.menus = arr.slice(0,len);
          this.elmenu = arr[len-1];
          this.elmenu.index = len-1;

        }
          
        }).catch(function (err) {
          console.log(err);
        })
    },
  },
  //     dom挂载之后
  mounted () {
    this.$nextTick(() => {

      if (this.$route.name == 'searchone' || this.$route.name == 'searchtwo') {
        this.value = this.$route.query.type;
        this.word = this.$route.query.word;
      }

    })
    this.initUserInfo()
  },
  //    dom挂载之前
  created () {
    let token = localStorage.getItem('token');
    this.getAllMenus(token);

    this.$http.get(this.$store.state.api + '/map.html?token=' + token, ).then(res => {
      if (res.data.code != 200) {
        localStorage.removeItem('token');
        if (this.$route.query.activity == '1') {
          return false;
        }
        this.$router.push({
          path: '/system/login',
        })
      }
    }).catch(function (err) {
      console.log(err);
    });


  },
  //    组件
  components: {},
  //    计算函数
  computed: {
  },
}
</script>
<style lang="scss" type="text/scss">
@import "../../style/css/helpers/mixin";

.header {
  background-color: #fffdfd;
  height: 70px;
  line-height: 70px;
  width: 100%;
  border-bottom: 1px solid #ebe6e6;
  .header-box {
    width: 100%;
    position: relative;
    .header-lt {
      position: relative;
      text-align: center;
      cursor: pointer;
      border-right: 1px solid #ebe6e6;   
       }
    .header-search {
      margin-left: 25px;
      position: relative;
      &.sea-on {
        img {
          @include transform(translateX(175px));
          cursor: pointer;
        }
        input {
          @include transform(scale(1));
          @include opacity(1);
          @include transition(all 0.8s);
        }
      }
      img {
        position: absolute;
        left: 0;
        top: 30px;
        width: 16px;
        height: 16px;
        cursor: pointer;
        @include transition(all 0.8s);
        z-index: 999;
      }
      input {
        width: 200px;
        height: 32px;
        line-height: 32px;
        border-radius: 5px;
        box-sizing: border-box;
        margin-top: 2px;
        padding-left: 10px;
        font-size: 16px;
        outline: none;
        background: transparent;
        border: 1px solid #555;
        padding-right: 30px;
        @include transform(scale(0));
        @include opacity(0);
        @include transition(all 0.8s);
      }
    }
    .header-logo {
      img {
        @include absoluteCenter();
        /*width: 123px;*/
        height: 42px;
        cursor: pointer;
      }
    }
    .header-rt {
      width: 190px;
      height: 70px;
      text-align: center;
      background: #fec8c9;
      color: #fff;
      a {
        color: #fff;
        &:hover {
          color: #000;
        }
      }
    }
    .header-rt1 {
      width: 330px;
      height: 70px;
      text-align: center;
      @include userSelect;
      .el-button {
        margin-right: 20px;
        border-color: #555;
      }
      .nickname {
        font-size: 17px;
        color: #313131;
        cursor: pointer;
      }
      .out {
        font-size: 12px;
        color: #777;
        cursor: pointer;
        margin-left:5px;
      }
    }
  }
}
/*.fenlei .el-select .el-input.is-focus .el-input__inner{*/

.fenlei {
  height: 70px;
  margin-left: 20px;
  box-sizing: border-box;
  .el-select .el-input {
    .el-input__inner {
      width: 100px;
      border: 1px solid #555;
      color: #000;
    }
    .el-select__caret {
      color: #000;
    }
  }
}

.el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 69px !important;
    line-height: 69px !important;
    color:#000 !important;
}
.el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
  border-bottom: 0 !important;
}
.el-submenu__title i{
  color:#000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue